module.exports = __webpack_public_path__ + "static/img/004.a8d12eb3.png";